let cache = {
  customProducts: [],
};

export const getCachedProducts = () => cache.customProducts;
export const setCachedProducts = (products) => {
  cache.customProducts = products;
};
